import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPlusSquare, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { deleteGroupShot } from "../lib/imageData";

// TODO: move this to separate file and refactor
const DeleteImageIcon = (props) => {
    const deleteButtonOnClick = (e) => {
        e.preventDefault();

        deleteGroupShot(props.wipKey, props.shotKey);
        props.removeShotBykey && props.removeShotBykey(props.shotKey);
    };

    return props.isCompleted || props.isReadOnly ? (
        <FontAwesomeIcon icon={faBan} />
    ) : (
        <span className="delete-button">
            <FontAwesomeIcon onClick={deleteButtonOnClick} icon={faTrashAlt} />
            <p>
                <span onClick={deleteButtonOnClick}>Delete group shot</span>
            </p>
        </span>
    );
};

// TODO: move this to separate file and refactor
const SkipEditing = ({ canAdd, ...props }) => {
    const classes = classNames({
        "skip-image": true,
        "skip-unedited-image": props.deleteButton,
    });

    const skipImageIconAndText = (
        <Fragment>
            <FontAwesomeIcon icon={faBan} />
            <p>This image has been flagged for skip editing</p>
        </Fragment>
    );

    return (
        <Fragment>
            <div className={classes}>
                {props.deleteButton && !props.isReadOnly ? (
                    <DeleteImageIcon
                        shotKey={props.shotKey}
                        wipKey={props.wipKey}
                        removeShotBykey={props.removeShotByKey}
                        isCompleted={props.isCompleted}
                    />
                ) : (
                    skipImageIconAndText
                )}
            </div>
            {canAdd && (
                <div className="skip-control">
                    <button className="button" onClick={props.updateSkip}>
                        <FontAwesomeIcon icon={faPlusSquare} />
                    </button>
                </div>
            )}
        </Fragment>
    );
};

export default SkipEditing;
